<template>
  <loading-layout v-if="loading" :title="$t('common.loading')" />

  <error-layout v-else-if="error" :error="error" :message="$t('error.tryAgain')" />

  <centered-layout v-else-if="isFinished">
    <finished-message />
  </centered-layout>

  <v-container v-else-if="hasEmployeeInfo">
    <main-layout>
      <template v-slot:header>
        <welcome-message />
      </template>

      <template v-slot:info>
        <personal-info />
      </template>

      <template v-slot:form>
        <GenerateForm :initial-values="employeeInfo" :schema="schema" @update="setSchema">
          <template v-slot:beforeFields="{ sectionName, fields }">
            <component :is="renderTipComponent(sectionName, fields)" />
          </template>
        </GenerateForm>
      </template>
    </main-layout>
  </v-container>
</template>

<script>
import MainLayout from '@/views/layouts/MainLayout.vue';
import LoadingLayout from '@/views/layouts/LoadingLayout.vue';
import ErrorLayout from '@/views/layouts/ErrorLayout.vue';
import CenteredLayout from '@/views/layouts/CenteredLayout.vue';

import GenerateForm from '@/components/form-generator/GenerateForm.vue';
import PersonalInfo from '@/components/PersonalInfo.vue';
import WelcomeMessage from '@/components/messages/WelcomeMessage.vue';
import FinishedMessage from '@/components/messages/FinishedMessage.vue';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import TipForDocuments from '@/components/form-generator/TipForDocuments.vue';
import TipForPersonalData from '@/components/form-generator/TipForPersonalData.vue';
import fieldsParams from '@/components/form-generator/constants/fields';

export default {
  components: {
    CenteredLayout,
    ErrorLayout,
    LoadingLayout,
    MainLayout,
    GenerateForm,
    PersonalInfo,
    WelcomeMessage,
    FinishedMessage,
    TipForDocuments,
    TipForPersonalData,
  },
  mixins: [fieldsParams],
  data() {
    return {
      loading: false,
      error: false,
    };
  },
  computed: {
    ...mapState('candidate', ['employeeInfo', 'schema']),
    ...mapGetters('candidate', ['isFinished', 'hasEmployeeInfo']),
  },
  mounted() {
    this.fetchCandidateData();
  },
  methods: {
    ...mapActions('candidate', ['fetchCandidateForm']),
    ...mapMutations('candidate', ['setSchema']),

    async fetchCandidateData() {
      this.loading = true;

      try {
        await this.fetchCandidateForm();
      } catch (e) {
        this.error = e;
      } finally {
        this.loading = false;
      }
    },

    renderTipComponent(name, fields) {
      switch (name) {
        case 'documents':
          return this.hasDocumentField(fields) ? 'tip-for-documents' : null;
        case 'personal_data':
          return 'tip-for-personal-data';
        default:
          return null;
      }
    },
    hasDocumentField(fields) {
      return !!fields.find(({ name }) => {
        return this.fieldsParams[name] && this.fieldsParams[name].component === 'FileUploadField';
      });
    },
  },
};
</script>
